import React from 'react';
import {
  Box, Typography, Avatar, Card, CardContent,
  Divider, List, ListItem, ListItemText
} from '@mui/material';
import {
  Business, Phone, Email, LocationOn, Schedule,
  People, MiscellaneousServices, Work, Facebook,
  Twitter, LinkedIn, Instagram
} from '@mui/icons-material';

const ReviewDetailsStep = ({ formik, logoPreview }) => {
  return (
    <Box sx={{ p: 2 }}>
      <Typography
        variant='h5'
        gutterBottom
        sx={{
          color: '#1976d2',
          textAlign: 'center',
          mb: 3,
          fontWeight: 'bold'
        }}
      >
        Review Your Details
      </Typography>

      {/* Pharmacy Logo */}
      {formik.values.logo && (
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
          <Avatar
            src={logoPreview || (typeof formik.values.logo === 'string' ? formik.values.logo : '')}
            sx={{ width: 100, height: 100 }}
          />
        </Box>
      )}

      {/* General Information Section */}
      <Card variant='outlined' sx={{ mb: 2 }}>
        <CardContent>
          <Typography variant='h6' sx={{ mb: 1 }}>
            <Business sx={{ verticalAlign: 'middle', mr: 1 }} /> Pharmacy Information
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <Typography><strong>Name:</strong> {formik.values.pharmacy_name || 'N/A'}</Typography>
          <Typography><strong>Owner:</strong> {formik.values.owner_name || 'N/A'}</Typography>
          <Typography><strong>License Number:</strong> {formik.values.license_number || 'N/A'}</Typography>
        </CardContent>
      </Card>

      {/* Contact Information Section */}
      <Card variant='outlined' sx={{ mb: 2 }}>
        <CardContent>
          <Typography variant='h6' sx={{ mb: 1 }}>
            <Phone sx={{ verticalAlign: 'middle', mr: 1 }} /> Contact Information
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <Typography><Phone sx={{ verticalAlign: 'middle', mr: 1 }} /> {formik.values.phone_number || 'N/A'}</Typography>
          <Typography><Email sx={{ verticalAlign: 'middle', mr: 1 }} /> {formik.values.email || 'N/A'}</Typography>
          <Typography>
            <LocationOn sx={{ verticalAlign: 'middle', mr: 1 }} />
            {formik.values.address?.street || 'N/A'}, {formik.values.address?.city || 'N/A'}
          </Typography>
        </CardContent>
      </Card>

      {/* Operating Hours Section */}
      <Card variant='outlined' sx={{ mb: 2 }}>
        <CardContent>
          <Typography variant='h6' sx={{ mb: 1 }}>
            <Schedule sx={{ verticalAlign: 'middle', mr: 1 }} /> Operating Hours
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <Typography><strong>Days Open:</strong> {formik.values.operating_hours?.days_open?.join(', ') || 'N/A'}</Typography>
          <Typography>
            <strong>Weekday Hours:</strong>
            {formik.values.operating_hours?.weekdays?.start_time || 'N/A'} -
            {formik.values.operating_hours?.weekdays?.end_time || 'N/A'}
          </Typography>
          <Typography>
            <strong>Weekend Hours:</strong>
            {formik.values.operating_hours?.weekends?.start_time || 'N/A'} -
            {formik.values.operating_hours?.weekends?.end_time || 'N/A'}
          </Typography>
        </CardContent>
      </Card>

      {/* Social Media Section */}
      <Card variant='outlined' sx={{ mb: 2 }}>
        <CardContent>
          <Typography variant='h6' sx={{ mb: 1 }}>
            <People sx={{ verticalAlign: 'middle', mr: 1 }} /> Social Media
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <Typography>
            <Facebook sx={{ color: '#1877F2', verticalAlign: 'middle', mr: 1 }} />
            {formik.values.social_media?.facebook || 'N/A'}
          </Typography>
          <Typography>
            <Twitter sx={{ color: '#1DA1F2', verticalAlign: 'middle', mr: 1 }} />
            {formik.values.social_media?.twitter || 'N/A'}
          </Typography>
          <Typography>
            <LinkedIn sx={{ color: '#0077B5', verticalAlign: 'middle', mr: 1 }} />
            {formik.values.social_media?.linkedin || 'N/A'}
          </Typography>
          <Typography>
            <Instagram sx={{ color: '#E1306C', verticalAlign: 'middle', mr: 1 }} />
            {formik.values.social_media?.instagram || 'N/A'}
          </Typography>
        </CardContent>
      </Card>

      {/* Services Offered Section */}
      <Card variant='outlined' sx={{ mb: 2 }}>
        <CardContent>
          <Typography variant='h6' sx={{ mb: 1 }}>
            <MiscellaneousServices sx={{ verticalAlign: 'middle', mr: 1 }} /> Services Offered
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <List>
            {formik.values.services_offered.length > 0
              ? (
                  formik.values.services_offered.map((service, index) => (
                    <ListItem key={index}>
                      <ListItemText
                        primary={service.name}
                        secondary={service.description || 'No description provided'}
                      />
                    </ListItem>
                  ))
                )
              : (
                <Typography>N/A</Typography>
                )}
          </List>
        </CardContent>
      </Card>

      {/* Staff Directory Section */}
      <Card variant='outlined'>
        <CardContent>
          <Typography variant='h6' sx={{ mb: 1 }}>
            <Work sx={{ verticalAlign: 'middle', mr: 1 }} /> Staff Directory
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <List>
            {formik.values.staff_directory.length > 0
              ? (
                  formik.values.staff_directory.map((staff, index) => (
                    <ListItem key={index}>
                      <ListItemText
                        primary={staff.name}
                        secondary={staff.position || 'No position specified'}
                      />
                    </ListItem>
                  ))
                )
              : (
                <Typography>N/A</Typography>
                )}
          </List>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ReviewDetailsStep;
